// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1326": "139b0b334f99","2687": "53d5514f5225","2801": "0e8af8ba0d88","3330": "1852a85dfba9","3573": "ffd50735d5c1","3969": "920ac668affc","8540": "d729836002ca",}[chunkId] + ".css"
}